//----------------------------------------------
//save single marker
//----------------------------------------------
import { createUUID, replaceAll, uniqueArray } from '../../utils'
import { ReinosMaps } from '../../core'

ReinosMaps.prototype.saveMarker = function (mapID, marker, keys) {
  const self = this

  if (self.markers === undefined) {
    self.markers = {}
  }

  //set the map array
  if (self.markers[mapID] === undefined) {
    self.markers[mapID] = []
  }

  //get the index
  const index = self.markers[mapID].length

  //set markerNumber
  marker.markerNumber = index

  //set the uuuid
  marker.markerUUID = createUUID()

  //set the search keys
  let searchKeys = [index, marker.markerUUID]

  //add the extra keys
  if (typeof keys === 'string') {
    const _keys = keys.split(':')

    _keys.forEach(_key => {
      _key = _key.trim()
      searchKeys.push(_key)
      searchKeys.push(_key.toLowerCase())
      searchKeys.push(replaceAll(_key, ' ', '_'))
      searchKeys.push(replaceAll(_key, ' ', '_').toLowerCase())
      searchKeys.push(replaceAll(_key, ' ', '-'))
      searchKeys.push(replaceAll(_key, ' ', '-').toLowerCase())

      //remove duplicated
      searchKeys = uniqueArray(searchKeys)
    })
  }

  //set the arrays
  self.markers[mapID][index] = []
  self.markers[mapID][index]['keys'] = searchKeys
  self.markers[mapID][index]['marker'] = marker

  //update lnglngs array
  self.latlngs.push(marker.getLatLng().lat + ',' + marker.getLatLng().lng)

  return marker.markerNumber
}
